import { checkRule, conditionRender } from 'utils/helper';
import BorderLinearProgress from '../BorderLinearProgress';
import CountdownNew from '../CountdownNew';
import styles from './styles.module.css';

const BG = '#E9E9E9';
const LINER = '#FBC9BE';
const HEIGHT_BAR = '8px !important';
const WIDTH_BAR = 140;

const HotInfo = ({ title = 'Flash sale', productType, campaign, deal }) => {
  const curTime = new Date();
  const dealEndCampaign =
    productType === 'MEGA_DAY'
      ? campaign?.campaign?.endTime
      : campaign?.flashSaleTime?.find((item) => new Date(item.startTime) < curTime && new Date(item.endTime) > curTime)?.endTime;
  const percentLine = Math.round((campaign?.totalSoldQuantity / campaign?.totalQuantity) * 100);
  const percentLineDeal = Math.round((deal?.totalCurrentQuantity / deal?.totalDealQuantity) * 100);
  const totalSold = campaign?.totalSoldQuantity || deal?.quantity;

  return (
    <div className={styles.hotInfo}>
      <div className={styles.textContainer}>
        <span className={styles.text}>{title}</span>
      </div>
      <div className={styles.rightInfo}>
        {percentLineDeal ? (
          <span className={styles.countBuy}>{conditionRender(percentLineDeal) ? checkRule(percentLineDeal) : `Đã bán ${deal?.totalCurrentQuantity}`}</span>
        ) : (
          <span className={styles.countBuy}>{conditionRender(percentLine) ? checkRule(percentLine) : `Đã bán ${totalSold}`}</span>
        )}
        <BorderLinearProgress
          variant="determinate"
          value={percentLine || percentLineDeal || 5}
          width={WIDTH_BAR}
          height={HEIGHT_BAR}
          bgcolor={BG}
          bgliner={LINER}
          linerradius={0}
        />
        <div className={styles.timeDiscount}>
          <CountdownNew targetDate={dealEndCampaign || deal?.endTime} hasMoreText />
        </div>
      </div>
    </div>
  );
};

export default HotInfo;
